// tanstack
import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute(
  '/$accountId/_user/energyxplorer/alarms/advanced',
)({
  component: Outlet,
  staticData: { crumb: 'energy-analysis:alarm_setup.advanced_action' },
});
